export const PublicVisibilityOption = () => ({
  name: () => 'Public',
  description: () =>
    'Your profile is publicly searchable. Only employers can access your full profile, resumé and contact details.',
});

export const StandardVisibilityOption = () => ({
  name: () => 'Standard',
  description: () =>
    'Some employers can view and download your profile and resumé. They can also contact you directly or via SEEK.',
});
export const LimitedVisibilityOption = () => ({
  name: () => 'Limited',
  description: () =>
    'Some employers can view your profile, but not your resumé and can only contact you via SEEK.',
});
export const HiddenVisibilityOption = () => ({
  name: () => 'Hidden',
  description: () =>
    'Employers cannot search for you. Your profile can only be seen by employers as part of your job applications.',
});
